<div class="arrow"></div><div class="tooltip-inner"><ng-content></ng-content></div>


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.d.ts.NgbTooltipWindow.html